
const messages = {
  en: {
    dashboard: {
      title: 'Dashboard management',
      menuTitle: 'Dashboard',
      subtitle: 'View, search, create, edit and delete Dashboard',
      creating: 'Creating Dashboard',
      editing: 'Editing Dashboard',
      deleting: 'Deleting Dashboard',
      showing: 'Showing Dashboard',
      filters: 'Filters',
      deposito: 'Warehouse',
      selectCharts: 'Select Charts',
      labels: {
        nombre: 'name'
      },
      ventasPorMarca: {
        title: 'Sales by Brand',
        subtitle: 'No se'
      },
      ventasPorModelo: {
        title: 'Sales by Model',
        subtitle: 'No se 2'
      },
      ventasPorDia: {
        title: 'Sales by Date',
        subtitle: 'No se 2'
      },
      ticketPromedio: {
        title: 'Average Ticket'
      },
      ventasPorMes: {
        title: 'Sales by Month'
      },
      ventasPorMedioDePago: {
        title: 'Sales by Payment Method'
      },
      ventasPorDeposito: {
        title: 'Sales by Warehouse'
      },
      ventasPorTamanio: {
        title: 'Sales by Size'
      },
      productosMasVendidos: {
        title: 'Best Selling Products'
      },
      productosStockBajo: {
        title: 'Low Stock Products'
      },
      ingresosVsDescuentos: {
        title: 'Income vs Discounts/Charges'
      },
      devolucionesPorDia: {
        title: 'Returns by Day'
      },
      ordenesVentaPorDia: {
        title: 'Sales Orders by Day'
      },
      ordenesCompraPorDia: {
        title: 'Purchase Orders by Day'
      },
      flujoCajaPorDia: {
        title: 'Cash Flow by Day'
      }
    },
  },
  es: {
    dashboard: {
      title: 'Administración de Dashboard',
      menuTitle: 'Dashboard',
      subtitle: 'Ver, buscar, crear, editar, y borrar Dashboard',
      creating: 'Creando Dashboard',
      editing: 'Modificando Dashboard',
      deleting: 'Eliminando Dashboard',
      showing: 'Detalles de Dashboard',
      filters: 'Filtros',
      deposito: 'Depósito',
      selectCharts: 'Selecionar Gráficos',
      labels: {
        nombre: 'nombre'
      },
      ventasPorMarca: {
        title: 'Ventas por Marca',
        subtitle: 'No se'
      },
      ventasPorModelo: {
        title: 'Ventas por Modelo',
        subtitle: 'No se 2'
      },
      ventasPorDia: {
        title: 'Ventas por Día',
        subtitle: 'No se 2'
      },
      ticketPromedio: {
        title: 'Ticket Promedio'
      },
      ventasPorMes: {
        title: 'Ventas por Mes'
      },
      ventasPorMedioDePago: {
        title: 'Ventas por Medio de Pago'
      },
      ventasPorDeposito: {
        title: 'Ventas por Depósito'
      },
      ventasPorTamanio: {
        title: 'Ventas por Tamaño'
      },
      productosMasVendidos: {
        title: 'Productos Más Vendidos'
      },
      productosStockBajo: {
        title: 'Productos con Stock Bajo'
      },
      ingresosVsDescuentos: {
        title: 'Ingresos vs Descuentos/Recargos'
      },
      devolucionesPorDia: {
        title: 'Devoluciones por Día'
      },
      ordenesVentaPorDia: {
        title: 'Órdenes de Venta por Día'
      },
      ordenesCompraPorDia: {
        title: 'Órdenes de Compra por Día'
      },
      flujoCajaPorDia: {
        title: 'Flujo de Caja por Día'
      }
    },
  },
  pt: {
    dashboard: {
      title: 'Administração de Dashboard',
      menuTitle: 'Dashboard',
      subtitle: 'Ver, buscar, criar, editar e usar Dashboard',
      creating: 'Criando Dashboard',
      editing: 'Edição Dashboard',
      deleting: 'Apagando Dashboard',
      showing: 'Detalhes do Dashboard',
      filters: 'Filtros',
      deposito: 'Depósito',
      selectCharts: 'Selecionar Gráficos',
      labels: {
        nombre: 'nome'
      },
      ventasPorMarca: {
        title: 'Ventas por Marca',
        subtitle: 'No se'
      },
      ventasPorModelo: {
        title: 'Ventas por Modelo',
        subtitle: 'No se 2'
      },
      ventasPorDia: {
        title: 'Ventas por Dia',
        subtitle: 'No se 2'
      },
      ticketPromedio: {
        title: 'Ticket Medio'
      },
      ventasPorMes: {
        title: 'Vendas por Más'
      },
      ventasPorMedioDePago: {
        title: 'Vendas por Método de Pagamento'
      },
      ventasPorDeposito: {
        title: 'Vendas por Depósito'
      },
      ventasPorTamanio: {
        title: 'Vendas por Tamanho'
      },
      productosMasVendidos: {
        title: 'Produtos Mais Vendidos'
      },
      productosStockBajo: {
        title: 'Produtos com Estoque Baixo'
      },
      ingresosVsDescuentos: {
        title: 'Receitas vs Descontos/Cobranzas'
      }
    },
  }
}

export default messages
